import type { SVGProps } from 'react';
const SvgCheckStreamlineCoreLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}>
    <desc>{'Check Streamline Icon: https://streamlinehq.com'}</desc>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m.5 9 3.222 2.82a1 1 0 0 0 1.433-.12L13.5 1.5"
    />
  </svg>
);
export default SvgCheckStreamlineCoreLine;
